import script from "./footerNav.vue?vue&type=script&setup=true&name=footerNav&lang=js"
export * from "./footerNav.vue?vue&type=script&setup=true&name=footerNav&lang=js"

import "./footerNav.vue?vue&type=style&index=0&id=2f3f6b4f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f3f6b4f"]])

export default __exports__